module.exports = __webpack_public_path__ + "static/media/import-file.b848a017.svg";